import { render, staticRenderFns } from "./QualityTvRow.vue?vue&type=template&id=fc4e1460&scoped=true"
import script from "./QualityTvRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./QualityTvRow.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./QualityTvRow.vue?vue&type=style&index=0&id=fc4e1460&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4e1460",
  null
  
)

export default component.exports